// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__fIo_i","description":"PatientConsentPreview_description__wUwAT"};